// extracted by mini-css-extract-plugin
export default {"resloader":"CartCard_resloader__XF9R4","loader":"CartCard_loader__irdsM","resbox":"CartCard_resbox__QVEIS","box":"CartCard_box__-GmlM"};